import React from 'react'
import Button from '@components/Button'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function ActionButtons(props) {
  const {setOpenResume} = props
  const router = useRouter()
  const {t} = useTranslation('website', {keyPrefix: 'order.cart'})

  function checkPlease() {
    router.push('/checkout-on-table/checkout')
  }

  function continueOrdering() {
    setOpenResume(false)
    if (router.asPath !== '/pedir') router.push('/pedir')
  }

  return (
    <div className={styles.container}>
      <Button fullWidth primary onClick={checkPlease}>
        {t('payAndCloseTable')}
      </Button>
      <div className={styles.button}>
        <Button onClick={continueOrdering} fullWidth>
          {t('continueOrderingToTable')}
        </Button>
      </div>
    </div>
  )
}
